// Generate ECDH P-256 key pair and export as JWKs (public and private).
// Flutter parity: lib/presentation/utils/e2ee_key_generator.dart:3-7
// (EcdhPrivateKey.generateKey(EllipticCurve.p256)) and
// lib/services/app_authentication_service.dart:529-531 (exportJsonWebKey on
// both keys). The exported JWK shape (kty: 'EC', crv: 'P-256', x, y, d) is
// what TextEncryptionService.initialize imports via
// crypto.subtle.importKey('jwk', ..., { name: 'ECDH', namedCurve: 'P-256' }).
//
// Key usage MUST be ['deriveBits'] — ECDH keys cannot be used for
// encrypt/decrypt; they only derive shared bits. extractable: true is
// required so exportKey('jwk', ...) can run on the private key (matches
// Flutter webcrypto where exportJsonWebKey() is callable on both halves).
export class E2EEKeyGenerator {
  async generateE2EEKeys(): Promise<{ publicJwk: JsonWebKey; privateJwk: JsonWebKey }> {
    const subtle = window.crypto.subtle;
    const keyPair = await subtle.generateKey(
      { name: 'ECDH', namedCurve: 'P-256' },
      true,
      ['deriveBits']
    );

    const publicJwk = await subtle.exportKey('jwk', keyPair.publicKey);
    const privateJwk = await subtle.exportKey('jwk', keyPair.privateKey);
    return { publicJwk, privateJwk };
  }
}

export const e2eeKeyGenerator = new E2EEKeyGenerator();
